module.exports = __webpack_public_path__ + "img/hyal-4.ed124e51.png";